import { render } from "./Index.vue?vue&type=template&id=8b527886&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=8b527886&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\www\\yunmuyuan_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b527886"]])

export default __exports__